/* eslint-disable no-unused-vars */

import red from '@mui/material/colors/red';
import deepOrange from '@mui/material/colors/deepOrange';

/* eslint-enable no-unused-vars */

const settings = {
  title: 'Smart&Nimble – Marketing, Automation, Intelligent Algorithms',
  description: "Do you have what it takes to fully embrace cloud solutions and intelligent algorithms for your business? Take our free quiz to find out!",
  homeURL: 'https://smartandnimble.com/',

  theme: {
    primaryColor: {
      name: 'red',
      import: red
    },
    secondaryColor: {
      name: 'deep-orange',
      import: deepOrange
    },
    type: 'dark'
  },

  credentials: {
    firebase: {
      apiKey: "AIzaSyAhATyQ3-BhQsQIcnMGr5A3y5Ckpmm4KlU",
      authDomain: "smartandnimble.firebaseapp.com",
      databaseURL: "https://smartandnimble.firebaseio.com",
      projectId: "smartandnimble",
      storageBucket: "smartandnimble.appspot.com",
      messagingSenderId: "379719941408",
      appId: "1:379719941408:web:c1f0936ef2d0c77ab66b45",
      measurementId: "G-L8THR7QM40"
    }
  }
};

export default settings;
